'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = withSize;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultBreakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withSize() {
  var overrideBreakPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mergedBreakpoints = (0, _extends3.default)({}, defaultBreakpoints, overrideBreakPoints);
  var breakpoints = (0, _keys2.default)(mergedBreakpoints).map(function (key) {
    return { breakpoint: key, width: mergedBreakpoints[key] };
  }).sort(function (a, b) {
    return b.width - a.width;
  });

  return function (WrappedComponent) {
    var WithSizeComponent = function (_React$Component) {
      (0, _inherits3.default)(WithSizeComponent, _React$Component);

      function WithSizeComponent(props) {
        (0, _classCallCheck3.default)(this, WithSizeComponent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithSizeComponent.__proto__ || (0, _getPrototypeOf2.default)(WithSizeComponent)).call(this, props));

        _this.getSize = function () {
          var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          var size = breakpoints.find(function (point) {
            return width >= point.width;
          }) || breakpoints[breakpoints.length - 1];

          return size;
        };

        _this.handleResize = function () {
          var size = _this.getSize();

          if (size !== _this.state.size) {
            _this.setState({
              size: size
            });
          }
        };

        _this.state = {
          size: _this.getSize()
        };
        return _this;
      }

      (0, _createClass3.default)(WithSizeComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          window.addEventListener('resize', this.handleResize);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          window.removeEventListener('resize', this.handleResize);
        }
      }, {
        key: 'render',
        value: function render() {
          var size = this.state.size;

          return _react2.default.createElement(WrappedComponent, (0, _assign2.default)({}, this.props, {
            size: size
          }));
        }
      }]);
      return WithSizeComponent;
    }(_react2.default.Component);

    WithSizeComponent.displayName = 'WithSizeComponent(' + getDisplayName(WrappedComponent) + ')';

    return WithSizeComponent;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/withSize.js
// module id = 1159
// module chunks = 0